// extracted by mini-css-extract-plugin
export default {"folder":"BackButton_folder__M9jGS","icon":"BackButton_icon__V8y8z","label":"BackButton_label__d2RMx","folderList":"BackButton_folderList__CtCkG"};